import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../../i18n";
import { api } from "../../lib/api";
import { StatCard, StatusBadge } from "../../components/app/widgets";

export default function StaffDashboard() {
  const { t, lang } = useI18n();
  const nav = useNavigate();
  const [cases, setCases] = useState([]);
  const [wl, setWl] = useState(null);

  useEffect(() => {
    api.get("/cases").then((r) => setCases(r.data)).catch(() => {});
    api.get("/admin/workload").then((r) => setWl(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6 gc-fade-up">
      <h1 className="font-display text-2xl font-bold text-[hsl(217_63%_15%)]">{t("nav_queue")}</h1>
      {wl && (
        <div className="grid sm:grid-cols-3 gap-4">
          <StatCard testid="q-specialist" label={t("specialist_queue")} value={wl.specialist_queue} accent="hsl(199 89% 48%)" />
          <StatCard testid="q-supervisor" label={t("supervisor_queue")} value={wl.supervisor_queue} accent="hsl(217 63% 15%)" />
          <StatCard testid="q-quality" label={t("quality_queue")} value={wl.quality_queue} accent="hsl(262 60% 55%)" />
        </div>
      )}
      {wl && wl.staff && (
        <div className="rounded-2xl border border-border bg-card overflow-hidden" data-testid="workload-hours">
          <div className="px-4 py-3 text-sm font-semibold text-[hsl(217_63%_15%)] border-b border-border">{t("hours_worked")}</div>
          <table className="w-full text-sm">
            <thead className="bg-secondary/60 text-muted-foreground text-xs"><tr>
              <th className="text-start px-4 py-3 font-medium">{t("name")}</th>
              <th className="text-start px-4 py-3 font-medium">{t("assigned")}</th>
              <th className="text-start px-4 py-3 font-medium">{t("hours_worked")}</th>
            </tr></thead>
            <tbody>
              {wl.staff.map((s) => (
                <tr key={s.id} data-testid={`staff-hours-${s.id}`} className="border-t border-border">
                  <td className="px-4 py-3 font-medium">{s.name}</td>
                  <td className="px-4 py-3">{s.assigned}</td>
                  <td className="px-4 py-3 font-mono font-bold text-[hsl(158_64%_28%)]">{s.hours} {t("hours")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div className="rounded-2xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/60 text-muted-foreground text-xs"><tr>
            <th className="text-start px-4 py-3 font-medium">{t("reference")}</th>
            <th className="text-start px-4 py-3 font-medium hidden sm:table-cell">{t("nav_clients")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("service")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("status")}</th>
          </tr></thead>
          <tbody>
            {cases.map((c) => (
              <tr key={c.id} data-testid={`staff-case-${c.id}`} onClick={() => nav(`/app/cases/${c.id}`)} className="border-t border-border hover:bg-secondary/40 cursor-pointer">
                <td className="px-4 py-3 font-mono text-xs font-medium text-[hsl(217_63%_15%)]">{c.reference}</td>
                <td className="px-4 py-3 hidden sm:table-cell">{c.organization_name}</td>
                <td className="px-4 py-3">{lang === "ar" ? c.service_label_ar : c.service_label_en}</td>
                <td className="px-4 py-3"><StatusBadge status={c.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
